export function showContents() {
    var showContentsButton = document.querySelector('.site-event-details__contents--show-more');
    var showContents = document.querySelector('.site-event-details__contents-list');
    showContentsButton.addEventListener('click', () => {
        showContents.classList.toggle('site-event-details__contents-list--active')
    });

}